import { render, staticRenderFns } from "./MyProjectsContractDocuments.vue?vue&type=template&id=2cb47966&scoped=true"
import script from "./MyProjectsContractDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsContractDocuments.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsContractDocuments.vue?vue&type=style&index=0&id=2cb47966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb47966",
  null
  
)

export default component.exports